import { Box, Typography } from '@mui/material';
import React from 'react';
import SettingsSelect from 'src/components/select/SettingsSelect';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'src/store/store';
import { updateFormField } from 'src/features/settings/courtLocationSlice';
import { stateDistricts } from 'src/data/stateDistricts';
import { TextField } from 'src/components/new/inputs/TextField';

const CourtLocationForm: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const formData = useSelector((state: RootState) => state.settings.courtLocation.formData);

  const errors = useSelector((state: RootState) => state.settings.courtLocation.formDataErrors);

  const states = useSelector((state: RootState) => state.settings.courtLocation.states);

  return (
    <Box
      component="form"
      display="flex"
      noValidate
      sx={{ width: '100%', margin: 0, padding: 0, gap: '1rem', flexDirection: 'column' }}
      alignItems="stretch"
    >
      <SettingsSelect
        required
        label="State"
        error={errors.stateError}
        data={states}
        onChange={(e) => {
          dispatch(updateFormField({ fieldName: 'state', value: e.target.value }));
        }}
        value={formData.state ?? ''}
      />
      <SettingsSelect
        label="District"
        error={errors.districtError}
        data={stateDistricts[formData.state]}
        onChange={(e) => dispatch(updateFormField({ fieldName: 'district', value: e.target.value }))}
        value={formData.district ?? ''}
        disabled={formData.state && stateDistricts[formData.state].length > 0 ? false : true}
      />
      <TextField
        id="division"
        name="division"
        label="Division"
        error={errors.divisionError}
        helperText={errors.divisionError}
        value={formData.division ?? ''}
        onChange={(e) => dispatch(updateFormField({ fieldName: 'division', value: e.target.value }))}
      />
    </Box>
  );
};

export default CourtLocationForm;
